import axios from 'axios';
import { get } from 'lodash';
import { logger } from '@fiverr-private/obs';
import { getLoggingContext } from '../../utils/loggingContext';
import HttpStatusCode from '../../types/httpStatusCode';

export const parseErrorResponse = (error) => ({
    status: get(error.response, 'request.status', HttpStatusCode.SERVER_ERROR),
    errorKey: get(error.response, 'data.errorKey')
});

export const errorInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            const { status, errorKey } = parseErrorResponse(error);
            error.key = errorKey;

            if (status >= HttpStatusCode.SERVER_ERROR) {
                logger.error(error, {
                    description: 'Error caught by axios interceptor',
                    ...getLoggingContext()
                });
            }

            return Promise.reject(error);
        });
};

// Since we're adding an interceptor we need to create a new instance of axios so
// This interceptor won't affect other axios calls
const axiosInstance = axios.create();
errorInterceptor(axiosInstance);

export default axiosInstance;
